import React from "react";
import HomeIdInput from "./HomeIdInput";

// A home in a list: its name when the Health summary has given it, and its id.
export const HomeLabel = ({ id, name }) => (
  <span className="hx-adm-home">
    {name ? <span className="hx-adm-home-name">{name}</span> : null}
    <span className={`hx-adm-id ${name ? "" : "is-main"}`}>{id}</span>
  </span>
);

// The test (pilot) homes: Automation is on for them even while it's off for
// every home. Adding and removing go to onChange("add" | "remove", id).
const PilotHomes = ({ pilotHomes, nameOf, disabled, onChange }) => (
  <>
    <p className="hx-adm-text">Automation is on for these homes even while it's off for every home.</p>
    {pilotHomes.length ? (
      <ul className="hx-adm-homes">
        {pilotHomes.map((id) => (
          <li key={id}>
            <HomeLabel id={id} name={nameOf(id)} />
            <button
              type="button"
              className="hx-adm-link is-danger"
              disabled={disabled}
              onClick={() => onChange("remove", id)}
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
    ) : (
      <p className="hx-adm-empty">No test homes yet.</p>
    )}
    <HomeIdInput
      idPrefix="hx-adm-pilot"
      label="Add a test home"
      exclude={pilotHomes}
      disabled={disabled}
      onAdd={(id) => onChange("add", id)}
    />
  </>
);

export default PilotHomes;
